import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik';
import { TextField, Select } from 'formik-material-ui';
import { Grid, InputLabel, MenuItem, FormControl, FormHelperText } from '@material-ui/core';
import useStyles from '../../Support-form.style';
import whatsapp from './ICON1.png';
import freshchat from './ICON2.png';

const FormComponent = ({ config, initialValues = {}, errors = {} }) => {
    const classes = useStyles();
    const [isChatOpen, setIsChatOpen] = useState(false);

    const isMobile = window.innerWidth <= 600;

    useEffect(() => {
        window.fcWidget.init({
            config: {
                cssNames: {
                    widget: 'bg_fc_frame',
                    open: 'bg_fc_open',
                    expanded: 'bg_fc_expanded'
                },
                headerProperty: {
                    direction: 'ltr',
                    hideChatButton: true
                }
            },
            token: "d2873638-61f1-4548-97d7-2996489d31f9",
            host: "https://wchat.eu.freshchat.com",

        });

        window.fcWidget.user.setProperties({
            firstName: initialValues.fName,
            lastName: initialValues.lName,
            email: initialValues.email,
            did: initialValues.did,
            uid: initialValues.did,
            plt: initialValues.plt,
            lang: initialValues.lang,
            inid: initialValues.inid,
            fbid: initialValues.fbid,
            tSe: initialValues.tSe
        });

        return () => window.fcWidget.destroy();

    }, [initialValues]);

    useEffect(() => {
        window.fcWidget.on("widget:closed", function (resp) {
            console.log('Widget Closed');
            window.fcWidget.setConfig({ fullscreen: false });
        });
    }, [isChatOpen, setIsChatOpen])


    function openFCwidgetMobile() {
        if (window.fcWidget.isLoaded()) {
            window.fcWidget.setConfig({ fullscreen: isMobile });
            window.fcWidget.open();
        }
    }

    const ChatIcons = () => (
        <Grid item xs={12}>
            <div class='chat-btn'>
                <div className='freshchat'>
                    <img src={freshchat} alt="freshchat" onClick={openFCwidgetMobile} />
                </div>
                <div className='whatsapp'>
                    <a href="https://api.whatsapp.com/send?phone=37259619711" rel="noreferrer" target="_blank">
                        <img src={whatsapp} alt="Whatsapp" />
                    </a>
                </div>
            </div>
        </Grid>
    )

    return (
        <>
            {isMobile ? <ChatIcons /> : null}
            {!isMobile ?
                <div id="icon-holder">
                    <div className="chat-btn column">
                        <div id='whatsapp-icon-desktop'>
                            <a href="https://api.whatsapp.com/send?phone=37259619711" rel="noreferrer" target="_blank">
                                <img src={whatsapp} alt="Whatsapp" />
                            </a>
                        </div>
                        <div className='freshchat'>
                            <img src={freshchat} alt="freshchat" onClick={openFCwidgetMobile} />
                        </div>
                    </div>
                </div>
                : null}
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="fName"
                    name="fName"
                    label={config.form.fName.label}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="lName"
                    name="lName"
                    label={config.form.lName.label}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    id="nickname"
                    name="nickname"
                    label={config.form.nickname.label}
                    fullWidth
                />

            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    id="phoneNumber"
                    name="phoneNumber"
                    label={config.form.phoneNumber.label}
                    type="number"
                    fullWidth
                />

            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="email"
                    name="email"
                    label={config.form.email.label}
                    type="email"
                    style={{ textAlign: 'end', direction: 'ltr' }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="emailVerification"
                    name="emailVerification"
                    label={config.form.emailVerification.label}
                    type="email"
                    style={{ textAlign: 'start', direction: 'ltr' }}
                    fullWidth />

            </Grid>
            <Grid item xs={12}>
                <FormControl className={classes.formControl} error={'subject' in errors} fullWidth>
                    <InputLabel htmlFor="subject">{config.form.subject.label}</InputLabel>
                    <Field
                        id="subject"
                        component={Select}
                        required
                        name="subject"
                        inputProps={{
                            id: 'subject',
                        }}>
                        {config.form.subject.options.map(item => (
                            <MenuItem key={item.text} value={item.value}>{item.text}</MenuItem>
                        ))}
                    </Field>
                    {
                        'subject' in errors ? <FormHelperText>This filed is required.</FormHelperText> : null
                    }
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Field
                    component={TextField}
                    required
                    multiline
                    rows={12}
                    id="message"
                    name="message"
                    label={config.form.message.label}
                    fullWidth />
            </Grid>
        </>
    )
}

FormComponent.propTypes = {
    config: PropTypes.object,
    initialValues: PropTypes.object,
    errors: PropTypes.object
}

export default FormComponent;